import { render, staticRenderFns } from "./TabsNav.vue?vue&type=template&id=54c1d1c0&"
import script from "./TabsNav.vue?vue&type=script&lang=js&"
export * from "./TabsNav.vue?vue&type=script&lang=js&"
import style0 from "./TabsNav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports